export const translationMapper: Record<string, string> = {
  DE: 'de-DE',
  CH: 'de-CH',
};
